import {createStyles, makeStyles} from '@material-ui/core';
import {DISABLED_GRAY_COLOR} from 'src/style/variable';
export const spaceBottomStyle = {
  marginBottom: '0.5rem'
};
export const spaceTopStyle = {
  marginTop: '0.5rem'
};

export const gridStyle = {
  marginRight: '2.5rem',
  fontSize: '1.1rem'
};
export const buttonStyle = {
  height: '3.25rem',
  width: '14rem',
  fontSize: '1.25rem',
  textTransform: 'capitalize',
  marginRight: '8px'
};

export const CCMEnrollStyles = makeStyles(() =>
  createStyles({
    ConsentRadioStyle: {
      '& .MuiRadio-root': {
        padding: '9px 2px 9px 9px'
      }
    },
    optionalFieldsWrapper: {
      display: 'flex',
      gap: '1rem',
      flexDirection: 'column',
      marginBottom: '1rem'
    }
  })
);
export const equalHalfwidthStyle = {
  flex: '1'
};
export const gridPadding = {
  paddingBottom: 0
};

export const billingMonthTextColor = {
  color: DISABLED_GRAY_COLOR
};
